/** Pure helpers for the admin Catalogue page. */

export const gbp = (pence: number): string => `£${(pence / 100).toFixed(2)}`;

/** Per-tag price, e.g. "£0.33". */
export function pencePerTag(pricePence: number, units: number): string {
  return units > 0 ? gbp(pricePence / units) : "—";
}

export function priceConfirmText(
  sku: string,
  fromPence: number,
  toPence: number,
  mode: "live" | "test",
): string {
  return (
    `Change ${sku} from ${gbp(fromPence)} to ${gbp(toPence)} on ${mode === "live" ? "LIVE" : "SANDBOX"} Stripe? ` +
    "A new Stripe Price is created and the old one archived; the website and app pick it up within about a minute."
  );
}
